import {gql} from '@apollo/client';

export const GetAllPricingGroups = gql`
    query GetAllPricingGroups($institutionSetIds: [InstitutionSetId!]) {
        finance {
            pricingGroups {
                list(institutionSetIds: $institutionSetIds) {
                    pricingGroupId
                    title
                    deleted
                }
            }
        }
    }
`;

export const GetAllRuleGroups = gql`
    query GetAllRuleGroups($siteId: InstitutionId!) {
        institutions(institutionId: $siteId) {
            ruleGroups(namespace: "pricing") {
                ruleGroupId
                ruleGroupName
            }
        }
    }
`;

const ParentBookingSettings = gql`
    fragment ParentBookingSettings on ParentPurchaseSettings {
        institutionId
        pricingGroupId
        ruleGroupId
        groupId
        sessionIds
        productIds
        enabled
    }
`;

export const GetParentBookingSettings = gql`
    query GetParentBookingSettings($institutionId: InstitutionId!) {
        finance {
            parentPurchaseSettings {
                getParentPurchaseSettings(institutionId: $institutionId) {
                    ...ParentBookingSettings
                    behaviors {
                        behaviorId
                    }
                }
            }
        }
    }

    ${ParentBookingSettings}
`;

export const UpdateParentBookingSettings = gql`
    mutation UpdateParentBookingSettings(
        $institutionId: InstitutionId!
        $defaultPricingGroupId: PricingGroupId!
        $defaultRuleGroupId: RuleGroupId
        $defaultGroupId: GroupId
        $sessionIds: [SessionId!]!
        $productIds: [ProductId!]!
        $enabled: Boolean
    ) {
        finance {
            parentPurchaseSettings {
                setParentPurchaseSettings(
                    institutionId: $institutionId
                    defaultPricingGroupId: $defaultPricingGroupId
                    defaultRuleGroupId: $defaultRuleGroupId
                    defaultGroupId: $defaultGroupId
                    sessionIds: $sessionIds
                    productIds: $productIds
                    enabled: $enabled
                ) {
                    ...ParentBookingSettings
                }
            }
        }
    }

    ${ParentBookingSettings}
`;
